var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalNodes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.38 4.5c0-.83-.68-1.5-1.5-1.5h-3.76a1.5 1.5 0 100 3h3.76c.82 0 1.5-.67 1.5-1.5zm1.5 0a3 3 0 01-3 3h-3.76a3 3 0 010-6h3.76a3 3 0 013 3zM9.75 19.5c0-.83-.67-1.5-1.5-1.5H4.5a1.5 1.5 0 000 3h3.75c.83 0 1.5-.67 1.5-1.5zm1.5 0a3 3 0 01-3 3H4.5a3 3 0 110-6h3.75a3 3 0 013 3zM21 19.5c0-.83-.67-1.5-1.5-1.5h-3.75a1.5 1.5 0 000 3h3.75c.83 0 1.5-.67 1.5-1.5zm1.5 0a3 3 0 01-3 3h-3.75a3 3 0 110-6h3.75a3 3 0 013 3zM16.5 14.25v-.75a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v.75a.75.75 0 01-1.5 0v-.75c0-1.24 1-2.25 2.25-2.25h3v-1.5a.75.75 0 011.5 0v1.5h3c1.24 0 2.25 1 2.25 2.25v.75a.75.75 0 01-1.5 0z"
  })));
}
export default SvgVerticalNodes;